// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2FnPx","buttons":"Footer_buttons__HkETy"};